export default __webpack_public_path__ + "static/media/time.60952627.svg";